<template>
  <div>
    <v-item-group
          class="v-btn-toggle vote-class"
          :value="attendee.attendedState"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                :value="0"
                :disabled="shouldDisableButton"
                large
                :class="attendee.attendedState === 0 ? 'active-vote-class' : ''"
                @click="changeAttendedState(0)"
              >
                <span
                  class="hidden-sm-and-down"
                  v-html="$t('agenda.InPerson')"
                ></span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipInPerson") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                :value="1"
                :disabled="shouldDisableButton"
                large
                :class="attendee.attendedState === 1 ? 'active-vote-class' : ''"
                @click="changeAttendedState(1)"
              >
                <span
                  class="hidden-sm-and-down"
                  v-html="$t('agenda.Remotely')"
                ></span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipRemotely") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                :value="2"
                :disabled="shouldDisableButton"
                large
                :class="attendee.attendedState === 2 ? 'active-vote-class' : ''"
                @click="changeAttendedState(2)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.Absent")
                }}</span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipAbsent") }}</span>
          </v-tooltip>
        </v-item-group>
        <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
export default {
  name: "AttendanceBtn",
  props: {
    attendee: Object,
    meetingObject: Object,
    isMeetingModified: Boolean,
  },
  components: {
    ConfirmDialog,
    MessageSheet
  },
  data() {
    return {
      message: "",
      messageType: "",
      displayMessage: false,
    };
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    shouldDisableButton() {
      const isUserAuthorized = this.attendee.id === this.$auth.user.user_id || this.updateMeetingPermission;
      return !isUserAuthorized || this.isMeetingModified;
    }
  },

  methods: {
    ...mapActions({
      updateMeetingAttendance: "meeting/updateMeetingAttendance",
    }),
    async changeAttendedState(state) {
      if(this.attendee.attendedState === state) return false;
      if (await this.$refs.confirm.open(
          this.$t("agenda.hConfirmAttendance"),
          this.$t("agenda.lblUpdateAttendance")
        )
      ) {
        const params = {
          tenantid: this.selectedTenant,
          meetingid: this.meetingObject.id,
          meetingTypeId: this.getMeetingTypeId,
          attendance_value: state == 0 ? 'present_inperson' : (state == 1 ? 'present_remotely' : 'absent'),
          attendee_id: this.attendee.id
        };
        try {
          await this.updateMeetingAttendance(params);
          this.showMessageSheet(this.$t("agenda.msgAttendanceUpdateSuccess"), "success");
        } catch (error) {
          console.log(error);
        }
      }
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  },
};

</script>
<style scoped>
.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle.vote-class .active-vote-class /deep/ .v-btn__content {
  color: white !important;
}

.v-btn-toggle.vote-class /deep/ .v-btn__content {
  color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle.vote-class .v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #fff !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group) .v-btn.v-btn--disabled {
  border-color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled.active-vote-class {
  background-color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled
  /deep/
  .v-btn__content {
  color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled.active-vote-class
  /deep/
  .v-btn__content {
  color: white !important;
}

.active-vote-class {
  opacity: inherit !important;
  background-color: var(--v-primaryDark2-base) !important;
}
</style>